import { gql } from 'graphql-tag'
import { settingsFragment } from '../admin/station/stationSettings/settingsQueries'
import { stationFragment } from '../station/stationQueries'

export const customerTargetFragment = gql`
  fragment CustomerTargetFragment on CustomerTarget {
    id
    station {
      ...StationFragment
    }
    productType
    target
    date
    calculatedTarget
  }
  ${stationFragment}
`

const dailySalesItemFragment = gql`
  fragment DailySalesItemFragment on DailySalesItem {
    date
    target
    salesVolume
    salesAmount
    productGroup
  }
`

const dailySalesDetailsFragment = gql`
  fragment DailySalesDetailsFragment on DailySalesDetails {
    notes
    date
  }
`

export const customerTargetPageQuery = gql`
  query CustomerTargetsPageQuery(
    $stationId: ID!
    $fromDate: String
    $toDate: String
    $lastYearFromDate: String
    $lastYearToDate: String
    $salesFromDate: String
    $salesToDate: String
  ) {
    customerTargetsBuffet: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: Buffet
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsALaCarte: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: ALaCarte
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsGroupBuffet: dailyBuffetReservationCustomerTarget(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      date
      target
    }
    customerTargetsGroupPizzaTable: dailyPizzaTableReservationCustomerTarget(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      date
      target
    }
    customerTargetsSweet: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: Sweet
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsSalty: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: Salty
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsGroupDining: dailyGroupDiningReservationCustomerTarget(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      date
      target
    }
    customerTargetsBurger: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: ABCBurger
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsPizza: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: ABCPizza
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsBreakfast: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: Breakfast
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsPizzatable: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: AbcPizzaTable
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsPikaCarte: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: PikaCarte
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsArnolds: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: Arnolds
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsBuffetWorld: customerTargets(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
      productType: AbcBuffetWorld
    ) {
      ...CustomerTargetFragment
    }
    customerTargetsGroupBuffetWorld: dailyBuffetWorldReservationCustomerTarget(
      stationId: $stationId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      date
      target
    }
    thisYearDailySales: dailySales(stationId: $stationId, fromDate: $salesFromDate, toDate: $salesToDate) {
      ...DailySalesItemFragment
    }
    lastYearDailySales: dailySales(stationId: $stationId, fromDate: $lastYearFromDate, toDate: $lastYearToDate) {
      ...DailySalesItemFragment
    }
    thisYearSalesDetails: dailySalesDetails(stationId: $stationId, fromDate: $salesFromDate, toDate: $toDate) {
      ...DailySalesDetailsFragment
    }
    lastYearSalesDetails: dailySalesDetails(
      stationId: $stationId
      fromDate: $lastYearFromDate
      toDate: $lastYearToDate
    ) {
      ...DailySalesDetailsFragment
    }
    stationSettings(stationId: $stationId) {
      ...SettingsFragment
    }
  }
  ${customerTargetFragment}
  ${dailySalesItemFragment}
  ${dailySalesDetailsFragment}
  ${settingsFragment}
`

export const upsertCustomerTargetsMutation = gql`
  mutation CreateAndUpdateCustomerTargets(
    $stationId: ID!
    $customerTargets: [CustomerTargetInputType!]
    $dailySalesDetails: [DailySalesDetailsInput!]
  ) {
    upsertCustomerTargets(stationId: $stationId, customerTargets: $customerTargets) {
      ...CustomerTargetFragment
    }
    upsertDailySalesDetails(stationId: $stationId, data: $dailySalesDetails) {
      ...DailySalesDetailsFragment
    }
  }
  ${customerTargetFragment}
  ${dailySalesDetailsFragment}
`
